package com.bikompanion.ui.mapper

enum class BikeScoreTone { Positive, Negative, Neutral }
